import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11c24440"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal",
  tabindex: "-1",
  role: "dialog"
}
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_3 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title d-flex flex-row align-items-center",
  style: {"flex":"1"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "View logs: ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-sync" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body p-3" }
const _hoisted_10 = { class: "header" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-calendar-clock" }),
  /*#__PURE__*/_createTextVNode(" Flow Start: ")
], -1))
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-eye fa-fw" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-timer" }),
  /*#__PURE__*/_createTextVNode(" Block Start: ")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-stopwatch" }),
  /*#__PURE__*/_createTextVNode(" Block Active: ")
], -1))
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "header" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-diagram-nested" }),
  /*#__PURE__*/_createTextVNode(" Previous Block: ")
], -1))
const _hoisted_20 = ["title"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa-duotone fa-fw fa-right-to-bracket" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa-duotone fa-fw fa-right-from-bracket" }, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "table table-data table-sm table-striped"
}
const _hoisted_25 = {
  key: 1,
  class: "table table-data table-sm table-striped"
}
const _hoisted_26 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.object)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.object.title), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-transparent btn-refresh",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getLogs && _ctx.getLogs(...args)))
              }, _hoisted_8),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'automation-flows-edit' })))
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (log, logIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: logIdx,
                  class: "log-item"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _hoisted_11,
                      _createTextVNode(" " + _toDisplayString(_ctx.formatDateAgo(log.context.start_time)) + " (" + _toDisplayString(_ctx.formatDate(log.context.start_time)) + ") ", 1),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-dark",
                        onClick: ($event: any) => (
                                        _ctx.$router.push({
                                            name: 'automation-flows-edit-context-log',
                                            params: { contextId: log.context.id },
                                        })
                                    )
                      }, _hoisted_14, 8, _hoisted_12)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_15,
                      _createTextVNode(" " + _toDisplayString(_ctx.formatDateAgo(log.start_time)) + " (" + _toDisplayString(_ctx.formatDate(log.start_time)) + ") ", 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_16,
                      _createElementVNode("span", {
                        title: _ctx.formatDate(log.active_time)
                      }, _toDisplayString(_ctx.formatDateDiff(log.start_time, log.active_time)), 9, _hoisted_17)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", null, [
                      _hoisted_19,
                      _createElementVNode("span", {
                        title: _ctx.formatDate(log.active_time)
                      }, _toDisplayString(log.previous ? log.previous.title : 'No previous block'), 9, _hoisted_20)
                    ]),
                    _createElementVNode("div", null, [
                      (log.fromConnection)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_21, [
                            _hoisted_22,
                            _createTextVNode(" " + _toDisplayString(log.fromConnection), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("small", null, [
                        _hoisted_23,
                        _createTextVNode(" " + _toDisplayString(log.toConnections.join(', ')), 1)
                      ])
                    ])
                  ]),
                  (log.previous)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_24, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log.previous.data, (value, key) => {
                            return (_openBlock(), _createElementBlock("tr", { key: key }, [
                              _createElementVNode("th", null, _toDisplayString(key), 1),
                              _createElementVNode("td", null, _toDisplayString(value), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("table", _hoisted_25, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log.context.data, (value, key) => {
                            return (_openBlock(), _createElementBlock("tr", { key: key }, [
                              _createElementVNode("th", null, _toDisplayString(key), 1),
                              _createElementVNode("td", null, _toDisplayString(value), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light",
                "data-dismiss": "modal",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'automation-flows-edit' })))
              }, " Close ")
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}